import * as THREE from 'three'
import { FACADE_MATERIAL_COLORS } from '../model/constants'

export const isFloorMesh = (obj: THREE.Object3D): obj is THREE.Mesh =>
  obj instanceof THREE.Mesh && obj.name.toLowerCase().includes('floor')

const createFacadeMaterial = (color: THREE.Color) =>
  new THREE.MeshStandardMaterial({
    color: color.clone(),
    roughness: 0.72,
    metalness: 0,
  })

const replaceMaterial = (
  mesh: THREE.Mesh,
  index: number,
  material: THREE.Material,
) => {
  const facadeColor = FACADE_MATERIAL_COLORS[material.name]
  if (!facadeColor) return

  const nextMaterial = createFacadeMaterial(facadeColor)

  if (Array.isArray(mesh.material)) {
    mesh.material[index] = nextMaterial
    return
  }

  mesh.material = nextMaterial
}

export const enhanceBuildingMaterials = (root: THREE.Object3D) => {
  root.traverse(child => {
    if (!(child instanceof THREE.Mesh) || isFloorMesh(child)) return

    if (Array.isArray(child.material)) {
      child.material.forEach((material, index) =>
        replaceMaterial(child, index, material),
      )
      return
    }

    replaceMaterial(child, 0, child.material)
  })
}
